import { makeActionCreator } from "../../utils";

export const ORDER_SCENARIO_CHANGED = "ORDERS.ORDER_SCENARIO_CHANGED";

export const orderScenarioChanged = makeActionCreator(ORDER_SCENARIO_CHANGED, "payload");
